module.exports = __webpack_public_path__ + "static/media/1.708b4011.png";